const rootClass = 'weet-components-badge';
const defaultOverflowCount = 999;
export { defaultOverflowCount, rootClass };
